export const styles = () => ({
  container: {
    flexBasis: '74%',
    minWidth: 670,
  },
})
